import { z } from 'zod';

export const permissionSchema = z.object({
  id: z.string(),
  resource: z.string(),
  action: z.string(),
});
